import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Box,
  Button,
  Tooltip,
  TextField as MUITextField,
  Badge,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import { useForceUpdate } from "../../../lib";
import { useSelector, shallowEqual } from "react-redux";
import { useFormikContext } from "formik";
import { DebouncedTextField } from "./DebouncedTextField";
import { MultiSelectChips } from "./MultiSelectChips";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const BandAndBuckle = (props) => {
  const selectStyles = {
    fontSize: "12px",
    height: "24px",
    padding: "2px 12px 2px 5px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    backgroundColor: "transparent",
    width: "100%",
  };

  let forceUpdate = useForceUpdate();
  const siteId = useSelector((state) => state.scopes.site_id);
  const { classes } = props;
  const { values, setFieldValue } = useFormikContext();
  // Visibility of the legacy `description` blob is now tracked by the
  // `show_description` column (1 = show on storefront, 0 = hide but retain data).
  // Fallback to truthy-description for items saved before the column existed.
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(
    values.show_description ?? !!values.description,
  );
  const {
    band_material: band_material_list,
    band_color: band_color_list,
    band_name: band_name_list,
    clasp_name: clasp_name_list,
    clasp_type: clasp_type_list,
    clasp_characteristic: clasp_characteristic_list,
    material: case_material_list,
  } = useSelector((state) => state.watches.watchLists, shallowEqual);

  return (
    <Accordion
      expanded={true}
      style={{
        width: "100%",
      }}
    >
      <AccordionSummary
        style={{ cursor: "default" }}
        aria-controls="panel1a-content"
        id="panel1a-header"
        tabIndex={-1}
      >
        <Typography>
          <Badge badgeContent={props.requiredBandBadge} color="secondary">
            Band & Buckle + Additional Details
          </Badge>
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        className={classes.grid}
        style={{
          display: "grid",
        }}
      >
        <Box
          display="flex"
          flexWrap="wrap"
          flexDirection="column"
          alignItems="left"
        >
          {/* ROW 0: General Band Notes (full width) */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
              <label style={{ fontSize: 11 }}>General Band Notes:</label>
              <DebouncedTextField
                className={
                  siteId !== 0
                    ? classes.gridTwoBlack
                    : values.general_band_notes
                    ? classes.gridTwoBlue
                    : classes.gridTwo
                }
                name="general_band_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* Band Row */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 150 }}>
              <label style={{ fontSize: 11 }}>Band Name:</label>
              <select
                disabled={siteId !== 0}
                value={values.band_name_id || ""}
                onChange={(e) => setFieldValue("band_name_id", e.target.value ? Number(e.target.value) : null)}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.band_name_id
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              >
                <option value=""></option>
                {band_name_list
                  ?.filter((b) => b.brand_id === values.brand_id || b.brand_id === null)
                  .map((b) => (
                    <option key={b.band_name_id} value={b.band_name_id}>{b.band_name}</option>
                  ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 250 }}>
              <label style={{ fontSize: 11 }}>Band Material:</label>
              <select
                disabled={siteId !== 0}
                value={values.band_material_id || ""}
                onChange={(e) => setFieldValue("band_material_id", e.target.value ? Number(e.target.value) : null)}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.band_material_id
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              >
                <option value=""></option>
                {band_material_list?.map((m) => (
                  <option key={m.band_material_id} value={m.band_material_id}>{m.band_material}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 160 }}>
              <label style={{ fontSize: 11 }}>Band Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.band_color_id || ""}
                onChange={(e) => setFieldValue("band_color_id", e.target.value ? Number(e.target.value) : null)}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.band_color_id
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              >
                <option value=""></option>
                {band_color_list?.map((c) => (
                  <option key={c.band_color_id} value={c.band_color_id}>{c.band_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 515 }}>
              <label style={{ fontSize: 11 }}>Band Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={
                  siteId !== 0
                    ? classes.gridTwoBlack
                    : values.band_notes
                    ? classes.gridTwoBlue
                    : classes.gridTwo
                }
                name="band_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* Buckle Row */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 230 }}>
              <label style={{ fontSize: 11 }}>Buckle Name:</label>
              <select
                disabled={siteId !== 0}
                value={values.clasp_name_id || ""}
                onChange={(e) => setFieldValue("clasp_name_id", e.target.value ? Number(e.target.value) : null)}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.clasp_name_id
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              >
                <option value=""></option>
                {clasp_name_list
                  ?.filter((c) => c.brand_id === values.brand_id)
                  .map((c) => (
                    <option key={c.clasp_name_id} value={c.clasp_name_id}>{c.clasp_name}</option>
                  ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 225 }}>
              <label style={{ fontSize: 11 }}>Buckle Type:</label>
              <select
                disabled={siteId !== 0}
                value={values.clasp_type_id || ""}
                onChange={(e) => setFieldValue("clasp_type_id", e.target.value ? Number(e.target.value) : null)}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.clasp_type_id
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              >
                <option value=""></option>
                {clasp_type_list?.map((t) => (
                  <option key={t.clasp_type_id} value={t.clasp_type_id}>{t.clasp_type}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 180 }}>
              <label style={{ fontSize: 11 }}>Buckle Material:</label>
              <MultiSelectChips
                disabled={siteId !== 0}
                value={values.clasp_material_ids || []}
                onChange={(ids) => setFieldValue("clasp_material_ids", ids)}
                options={case_material_list || []}
                getOptionValue={(m) => m.case_material_id}
                getOptionLabel={(m) => m.case_material}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.clasp_material_ids?.length
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 180 }}>
              <label style={{ fontSize: 11 }}>Buckle Char.:</label>
              <MultiSelectChips
                disabled={siteId !== 0}
                value={values.clasp_characteristic_ids || []}
                onChange={(ids) => setFieldValue("clasp_characteristic_ids", ids)}
                options={(clasp_characteristic_list || []).filter((c) => c.brand_id === values.brand_id || c.brand_id === null)}
                getOptionValue={(c) => c.clasp_characteristic_id}
                getOptionLabel={(c) => c.clasp_characteristic}
                className={
                  siteId !== 0
                    ? `${classes.gridTwoBlack} custom-select`
                    : values.clasp_characteristic_ids?.length
                    ? `${classes.gridTwoBlue} custom-select`
                    : `${classes.gridTwo} custom-select`
                }
                style={selectStyles}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 245 }}>
              <label style={{ fontSize: 11 }}>Buckle Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={
                  siteId !== 0
                    ? classes.gridTwoBlack
                    : values.clasp_notes
                    ? classes.gridTwoBlue
                    : classes.gridTwo
                }
                name="clasp_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {values.item_additional_band_refs?.map((value, index) => {
            return (
              <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
                <Box style={{ width: "12%", alignItems: "center" }}>
                  <Typography style={{ fontSize: 13 }}>Additional Band # {index + 1}:</Typography>
                </Box>
                <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 250 }}>
                  <label style={{ fontSize: 11 }}>Band Material:</label>
                  <select
                    disabled={siteId !== 0}
                    value={values.item_additional_band_refs[index].band_material_id || ""}
                    onChange={(e) => {
                      const newValue = e.target.value ? Number(e.target.value) : null;
                      setFieldValue(
                        "item_additional_band_refs",
                        values.item_additional_band_refs.map((row, i) =>
                          i === index ? { ...row, band_material_id: newValue } : row
                        )
                      );
                      forceUpdate();
                    }}
                    className={
                      siteId !== 0
                        ? `${classes.gridTwoBlack} custom-select`
                        : values.item_additional_band_refs[index].band_material_id
                        ? `${classes.gridTwoBlue} custom-select`
                        : `${classes.gridTwo} custom-select`
                    }
                    style={selectStyles}
                  >
                    <option value=""></option>
                    {band_material_list?.map((m) => (
                      <option key={m.band_material_id} value={m.band_material_id}>{m.band_material}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 160 }}>
                  <label style={{ fontSize: 11 }}>Band Color:</label>
                  <select
                    disabled={siteId !== 0}
                    value={values.item_additional_band_refs[index].band_color_id || ""}
                    onChange={(e) => {
                      const newValue = e.target.value ? Number(e.target.value) : null;
                      setFieldValue(
                        "item_additional_band_refs",
                        values.item_additional_band_refs.map((row, i) =>
                          i === index ? { ...row, band_color_id: newValue } : row
                        )
                      );
                      forceUpdate();
                    }}
                    className={
                      siteId !== 0
                        ? `${classes.gridTwoBlack} custom-select`
                        : values.item_additional_band_refs[index].band_color_id
                        ? `${classes.gridTwoBlue} custom-select`
                        : `${classes.gridTwo} custom-select`
                    }
                    style={selectStyles}
                  >
                    <option value=""></option>
                    {band_color_list?.map((c) => (
                      <option key={c.band_color_id} value={c.band_color_id}>{c.band_color}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 500 }}>
                  <label style={{ fontSize: 11 }}>Band Notes:</label>
                  <MUITextField
                    className={
                      siteId !== 0
                        ? classes.gridTwoBlack
                        : values.item_additional_band_refs[index].band_notes
                        ? classes.gridTwoBlue
                        : classes.gridTwo
                    }
                    value={values.item_additional_band_refs[index].band_notes || ""}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setFieldValue(
                        "item_additional_band_refs",
                        values.item_additional_band_refs.map((row, i) =>
                          i === index ? { ...row, band_notes: newValue } : row
                        )
                      );
                      forceUpdate();
                    }}
                    style={{ width: "100%" }}
                    multiline
                  />
                </div>
                <Box style={{ display: "flex", alignItems: "center", alignSelf: "flex-end" }}>
                  <Tooltip title="Delete Row">
                    <Button
                      disabled={siteId !== 0}
                      onClick={(event) => {
                        setFieldValue(
                          "item_additional_band_refs",
                          values.item_additional_band_refs.filter((_, i) => i !== index)
                        );
                        forceUpdate();
                      }}
                      style={{ minWidth: "unset", padding: "5px 4px" }}
                    >
                      <RemoveCircleOutlineOutlinedIcon color="secondary" fontSize="small" />
                    </Button>
                  </Tooltip>
                </Box>
              </Box>
            );
          })}

          <Box mx={1} display="flex" alignItems="center">
            <Box flex={1}>
              <FormControlLabel
                checked={showAdditionalDetails}
                control={
                  <Checkbox
                    onChange={(e, value) => {
                      // Toggle the visibility flag; intentionally do NOT clear
                      // `description` — data is retained for future re-parsing
                      // into structured attribute fields.
                      setShowAdditionalDetails(value);
                      setFieldValue("show_description", value ? 1 : 0);
                    }}
                    labelPlacement="start"
                    name="checkedA"
                  />
                }
                label="Show Additional Details"
              />
            </Box>
            <Button
              disabled={siteId !== 0}
              color="primary"
              variant="outlined"
              onClick={() => {
                setFieldValue("item_additional_band_refs", [
                  ...(values.item_additional_band_refs || []),
                  {
                    additional_band: true,
                    band_material_id: null,
                    band_color_id: null,
                    band_notes: null,
                  },
                ]);
              }}
            >
              Add Additional band
            </Button>
            <Box flex={1} />
          </Box>
          {showAdditionalDetails && (
            <Box m={1}>
              <style>{`.ql-editor { min-height: 72px; }`}</style>
              <ReactQuill
                value={values.description}
                onChange={(value) => {
                  if (value) {
                    setFieldValue("description", value);
                  } else {
                    setFieldValue("description", null);
                  }
                }}
              />
            </Box>
          )}
          <Box m={1} display="flex" justifyContent="space-between"></Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
